import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bowling-ball-outline",
  "use": "icon-bowling-ball-outline-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-bowling-ball-outline\"><title>Bowling Ball</title><circle cx=\"256\" cy=\"256\" r=\"208\" fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" stroke-width=\"32\" /><circle cx=\"288\" cy=\"200\" r=\"24\" /><circle cx=\"296\" cy=\"128\" r=\"24\" /><circle cx=\"360\" cy=\"168\" r=\"24\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol